import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const Context = React.createContext();
const defaultLayer = "surface";

export function LayersProvider({ children }) {
  const [activeLayer, updateActiveLayer] = useState(defaultLayer);

  return (
    <Context.Provider value={{ activeLayer, updateActiveLayer }}>
      {children}
    </Context.Provider>
  );
}

LayersProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

function useLayersContext() {
  const { activeLayer, updateActiveLayer } = React.useContext(Context);
  useEffect(() => {
    return () => updateActiveLayer(defaultLayer);
  }, [updateActiveLayer]);

  return {
    activeLayer,
    updateActiveLayer,
  };
}

export default useLayersContext;
